
<div class="dg-modal-header">
    <h2>Reject Photo</h2>
    <i (click)="action(false)" class="close-icon icon-cross_16px"></i>
</div>

<div class="dg-modal-body">

        <span class="reasons-picker-title">Please select a reject photo reason(s)</span>
        <div class="reasons-picker-block">
            <div class="reasons-picker-block__item" *ngFor="let option of rejectedReasons">
                <label>
                    <input type="checkbox" [disabled]="option.isExcluded" (click)="pickRejectReason(option)">
                    <span [class.disabled-checkbox]="option.isExcluded">{{option.rejectedPhotoReasonName}}</span>
                </label>
            </div>
        </div>

      
        <span class="details-title">Additional details</span>
        <div class="details-block">
            <textarea
                placeholder="Enter details"
                [maxLength]="textAreaCharLimit"
                [formControl]="reason"
            ></textarea>

            <div class="messages-container">
                <div class="character-limit-message">
                    {{ reasonCharacterCounter$ | async }}/{{ textAreaCharLimit }} character limit
                </div>
            </div>
        </div>

</div>
<div class="dg-modal-footer">
    <button 
        (click)="action(false)" 
        appTrackClickButton 
        id="dismiss" 
        type="button" 
        class="button secondary"
        >{{ buttonsTitle.dismiss }}
    </button>

    <button 
        (click)="submit()" 
        appTrackClickButton 
        id="confirm" 
        type="button" 
        class="button primary" 
        [disabled]="isSubmitDisabled"
        >{{ buttonsTitle.confirm }}
    </button>
</div>
